import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import LoaderBilan from "../LoaderBilan";
import SimpleDoughnutChart from "../SimpleGraphDoughnut";
import { useTheme } from "../../context/ThemeContext";

/**
 * Composant pour afficher le nombres d'equipements...
 * @param {string} title - titre de la carte
 * @param {number} number - longueur du tableau a afficher
 * @param {string} logo - URL si vous souhaitez afficher une image
 * @param {string} color - couleur du logo
 * @param {string} stylesIcons - arriere-plan du logo
 */
export default function StatisticsCard({ title, text, logo, data }) {
    const { theme } = useTheme();
    const { t } = useTranslation();

    const isServiceInactive = data === false;
    const isLoading = data === undefined;
    const hasData = data && typeof data === "object";
    const values = hasData ? Object.values(data) : [];
    const keys = hasData ? Object.keys(data) : [];
    const totalValue = hasData ? values.reduce((acc, curr) => acc + curr, 0) : 0;
    const isEmptyData = hasData && totalValue === 0;

    return (
        <div className="statistics-card">
            <div className="statistics-card-header">
                {logo && (
                    <span className="statistics-card-header-logo">
                        <img src={logo} alt={`Logo ${title}`} />
                    </span>
                )}
                <span className={`statistics-card-header-title ${title === "Meraki" ? "meraki-green" : ""}`}>
                    {t(title)}
                </span>
                <span className="statistics-card-header-tooltip">
                    <span className="card-components-header-info tooltip-container">
                        <FontAwesomeIcon icon={faInfo} />
                        <span className="tooltip-text">{text}</span>
                    </span>
                </span>
            </div>
            <div className="statistics-card-content">
                <div>
                    <div className="statistics-card-content-graph">
                        {isLoading ? (
                            <div className="dashboard-graph-doughnut-simple">
                                <LoaderBilan />
                            </div>
                        ) : isServiceInactive || isEmptyData ? (
                            <div className="dashboard-graph-doughnut-simple">
                                <span>0</span>
                            </div>
                        ) : (
                            <SimpleDoughnutChart
                                key={theme}
                                data={[data]}
                                colors={title === "Meraki" ? ["#7DDCFF", "#997ADB"] : title === "Iot" ? ["#997ADB", "#AEC353"] : ["#AEC353", "#DF2935"]}
                                legend={false}
                                total={true}
                                totalValue={totalValue}
                            />
                        )}
                    </div>
                </div>
                {isServiceInactive ? (
                    <span className="statistics-card-content-data-empty">
                        {t("Service non actif")}
                    </span>
                ) : isEmptyData ? (
                    <span className="statistics-card-content-data-empty">
                        {t(`Aucun équipement ${title} disponible`)}
                    </span>
                ) : (
                    <div className="statistics-card-content-data">
                        <span className="statistics-card-content-data-first">
                            <span>{keys[0]}</span>
                            <span>{values[0]}</span>
                        </span>
                        <span className="statistics-card-content-data-last">
                            <span>{keys[1]}</span>
                            <span>{values[1]}</span>
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}
